import type { ControllerFieldState } from 'react-hook-form';
import { forwardRef } from 'react';

import type { TextFieldProps } from '../../../../../components/Toolkit/Inputs/TextField';
import { usePanelContentsSubscribe } from '../../../../../components/CarFinancePage/components/Panels/shared/CollapsiblePanel/CollapsiblePanel.hook';
import { TextField } from './FinanceTextField.styled';
import { preventSubmit } from '../preventSubmit';

type FinanceTextFieldProps = Omit<
  TextFieldProps,
  'hasError' | 'errorMessage' | 'name'
> &
  ControllerFieldState & { name: string; isOptional?: boolean };

export const FinanceTextField = forwardRef<
  HTMLInputElement,
  FinanceTextFieldProps
>((props, ref) => {
  const { invalid, value, isOptional = false, ...rest } = props;
  usePanelContentsSubscribe({
    name: props.name,
    value,
    invalid,
    isOptional,
  });
  return (
    <TextField
      {...rest}
      hasError={invalid}
      errorMessage={props.error?.message}
      ref={ref}
      value={value}
      onKeyPress={preventSubmit}
    />
  );
});

FinanceTextField.displayName = 'FinanceTextField';
